<template>
  <div
    v-if="!isClosed"
    id="attributes-debugger"
    aria-hidden
    class="fixed bottom-0 right-0 z-toast mb-4 mr-12 overflow-auto rounded-md p-4 text-sm shadow-lg"
    style="background-color: #dcebff; max-width: 30rem; max-height: 40vh"
  >
    <div class="mb-2 flex items-start gap-2 between">
      <p class="fw-bold">
        Content Attributes
      </p>
      <base-button class="b rounded p-1 text-xs" @click="isClosed = true">
        Close
      </base-button>
    </div>
    <ul v-if="hasAttributes" class="list-disc pl-4">
      <li
        v-for="(value, key) in attributes"
        :key
        class="py-1"
        :style="{ paddingLeft: '0.5rem' }"
      >
        {{ key }}={{ value }}
      </li>
    </ul>
    <div v-else class="text-xs italic">
      No content attributes available
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PdpContextKey } from '#commerce/composables/usePdp/context'

const pdpContext = inject(PdpContextKey, null)

const isClosed = ref(false)

const attributes = computed(() => pdpContext?.product.value?.contentAttributes)

const hasAttributes = computed(() =>
  attributes.value && Object.keys(attributes.value).length > 0
)
</script>
